<template>
  <div class="page-main">
    <p style="padding: 30px;">
      <button type="button" class="btn" @click="onClear">삭제</button>
    </p>
  </div>
</template>
<script>
import { deleteCookie } from '@/util'

export default {
  methods: {
    onClear () {
      localStorage.clear()

      deleteCookie('lang')
    }
  }
}
</script>
